import CheckBox from 'devextreme-react/check-box';
import {useRef, useState} from 'react';
import {CloseOrderProps} from '../types/CloseOrderProps';
import './ClosedOrdersControl.scss';
import {DatePeriodSelector} from '../../../../components';
import {ValueChangedEvent} from 'devextreme/ui/check_box';
import {DatePeriodSelectorRef} from "../../../../components/date-period-selector/types/DatePeriodSelectorRef";


export default function ClosedOrdersControl(props: CloseOrderProps) {

    const [checked, setChecked] = useState(false);
    const ref = useRef<DatePeriodSelectorRef>(null);

    const onCheckBoxChanged = (e: ValueChangedEvent) => {
        setChecked(e.value);
        props.onClosedOrdersChanged({
            checked: e.value,
            dateFrom: e.value ? ref.current?.getPeriod() ?? null : null
        });
    };

    const onDatePeriodChanged = () => {
        props.onClosedOrdersChanged({checked, dateFrom: ref.current?.getPeriod() ?? null});
    }

    return (
        <div className="closed-orders">
            <CheckBox
                value={checked}
                text={props.text ?? "Closed/Cancelled Orders"}
                onValueChanged={onCheckBoxChanged}/>

            <DatePeriodSelector
                visible={checked}
                onPeriodChanged={onDatePeriodChanged}
                ref={ref}
            />
        </div>
    )
} 
